import React from 'react';
import styles from './StatsPanel.module.css';

const StatsPanel = () => {
  const stats = [
    {
      title: 'Ventas Totales',
      value: '$24,589',
      change: '+12.5%',
      isPositive: true,
      icon: '💰',
      color: '#10b981'
    },
    {
      title: 'Órdenes Hoy',
      value: '184',
      change: '+8.2%',
      isPositive: true,
      icon: '📦',
      color: '#3b82f6'
    },
    {
      title: 'Clientes Nuevos',
      value: '42',
      change: '+15.3%',
      isPositive: true,
      icon: '👥',
      color: '#8b5cf6'
    },
    {
      title: 'Tasa Conversión',
      value: '5.67%',
      change: '+2.1%',
      isPositive: true,
      icon: '📊',
      color: '#f59e0b'
    }
  ];

  return (
    <div className={styles.statsPanel}>
      {stats.map((stat, index) => (
        <div key={index} className={styles.statCard}>
          <div className={styles.statHeader}>
            <div 
              className={styles.statIcon}
              style={{ backgroundColor: stat.color }}
            >
              {stat.icon}
            </div>
            <div className={styles.statInfo}>
              <h3 className={styles.statValue}>{stat.value}</h3>
              <p className={styles.statTitle}>{stat.title}</p>
            </div>
          </div>
          <div className={`${styles.statChange} ${stat.isPositive ? styles.positive : styles.negative}`}>
            {stat.change}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsPanel;